module.exports = __webpack_public_path__ + "static/media/mano-movil-logotipo.c01c4c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mano-movil-logotipo.png
// module id = 148
// module chunks = 0